import React, { useEffect, useState } from "react"
import { injectIntl, defineMessages } from "react-intl"
import EcommerceConfiguration, {
    CreateEcommerceConfigurationDto
} from "../../../state/ecommerce-configuration/EcommerceConfigurationValues"
import EcommerceSettingMapping from "../../../state/ecommerce-configuration/EcommerceSettingMapping"
import EcommerceStyleMapping from "../../../state/ecommerce-configuration/EcommerceStyleMapping"
import { EcommerceRulesSet } from "../../../state/ecommerce-configuration/EcommerceRule"
import ActionButton from "../../../common/button/actionbutton.component.jsx"
import EcommerceSettingsMappingToggles from "../components/EcommerceSettingsTogglesComponent"
import EcommerceStylesMappingInputs from "../components/EcommerceStyleInputListComponent"
import { Intl } from "../../../state/helpers/IntlProps"
import { ECOMMERCE_CONFIGURATION_TYPE } from "../../../state/ecommerce-configuration/EcommerceTypes"
import QuoteFormConfiguration from "../../../state/ecommerce-configuration/EcommerceQuoteFormConfiguration"
import EcommerceConfigurationRulesEngineContainer from "./EcommerceConfigurationRulesEngineContainer"

type OwnProps = {
    configuration?: EcommerceConfiguration
    configurationType: ECOMMERCE_CONFIGURATION_TYPE
    handleSubmitCallback: (config: CreateEcommerceConfigurationDto) => void
    isSubmitEnabled: boolean
    intl: Intl
    formConfiguration?: QuoteFormConfiguration[]
}

const messages = defineMessages({
    "submit_btn": {
        id: "ecommerce.section.quote_cart_container.submit.label",
        defaultMessage: "Save",
    },
    [ECOMMERCE_CONFIGURATION_TYPE.ADD_TO_QUOTE_BUTTON]: {
        id: "settings.ecommerce.ecommerce_add_to_quote_container.edit_title",
        defaultMessage: "Edit Your Add To Quote Button"
    },
    [ECOMMERCE_CONFIGURATION_TYPE.FLOATING_QUOTE_BUTTON]: {
        id: "settings.ecommerce.floating_quote_cart_button.edit.title",
        defaultMessage: "Edit Your Floating Quote Cart Button"
    },
    [ECOMMERCE_CONFIGURATION_TYPE.QUOTE_CART]: {
        id: "settings.ecommerce.quotecart.edit.title",
        defaultMessage: "Edit Your External Quote Cart"
    },
    [ECOMMERCE_CONFIGURATION_TYPE.QUOTE_FORM]: {
        id: "settings.ecommerce.quoteform.edit.title",
        defaultMessage: "Edit Your External Quote Form"
    },
    [ECOMMERCE_CONFIGURATION_TYPE.RULES]: {
        id: "settings.ecommerce.rules.edit.title",
        defaultMessage: "Edit your rules"
    },
})

const EcommerceConfigurationContainer = (props: OwnProps) => {
    const [settingMapping, setSettingMapping] = useState<EcommerceSettingMapping>()
    const [styleMapping, setStyleMapping] = useState<EcommerceStyleMapping>()
    const [rulesSet, setRulesSet] = useState<EcommerceRulesSet>({
        showAddToQuoteRules: {rules: [], cssSelectors: "", enabled: false},
        hidePricesRules: {rules: [], cssSelectors: "", enabled: false},
        hideAddToCartButtonRules: {rules: [], cssSelectors: "", enabled: false},
    })
    const [reRenderFlag, setReRenderFlag] = useState(1)
    const [formConfigurations, setFormConfigurations] = useState<QuoteFormConfiguration[]>([])

    useEffect(() => {
        if (props.configuration) {
            setSettingMapping(props.configuration.getEcommerceSettingMappingByType(props.configurationType))
            setStyleMapping(props.configuration.getEcommerceStyleMappingByType(props.configurationType))

            if (props.configuration.getRulesMapping()) {
                setRulesSet(props.configuration.getRulesMapping())
            }
        }
    }, [props.configuration])

    useEffect(() => {
        if (props.formConfiguration) {
            setFormConfigurations(props.formConfiguration)
        }
    }, [props.formConfiguration])

    const handleOnSubmitCallback = () => {
        styleMapping?.setFormConfiguration(formConfigurations)
        const data: CreateEcommerceConfigurationDto = {
            configurationType: props.configurationType,
            settingMappings: settingMapping?.getAttributes() || Object(),
            styleMappings: styleMapping?.getAttributesAndForm() || Object(),
            rulesMapping: rulesSet || Object(),
        }
        props.handleSubmitCallback(data)
    }

    const handleOnChangeSettingCallback = (x: string) => {
        settingMapping?.setAttribute(x, !settingMapping.getAttributes()[x])
        setSettingMapping(settingMapping)
        triggerReRender()
    }

    const handleOnChangeStyleCallback = (field: string, value: string) => {
        styleMapping?.setAttribute(field, value)
        setStyleMapping(styleMapping)
        triggerReRender()
    }

    const handleOnChangeRulesSetCallback = (updatedRuleSet: EcommerceRulesSet) => {
        setRulesSet(updatedRuleSet)
        triggerReRender()
    }

    const triggerReRender = () => {
        setReRenderFlag(reRenderFlag + 1)
    }

    return (
        <div >
            <div className="col-12 ui-module pb-5">
                <div className="row">
                    <div className="col-12 ui-title-bar mb-3">
                        <div className="row">
                            <div className="col-12 ">
                                <h2>
                                    {props.intl.formatMessage(messages[props.configurationType])}
                                </h2>
                            </div>
                        </div>
                    </div>
                </div>

                <EcommerceSettingsMappingToggles
                    settingsMapping={settingMapping}
                    onChangeCallback={handleOnChangeSettingCallback}
                    key={reRenderFlag}/>

                <EcommerceStylesMappingInputs styleMapping={styleMapping}
                    onChangeCallback={handleOnChangeStyleCallback}/>

                {
                    props.configurationType == ECOMMERCE_CONFIGURATION_TYPE.RULES &&
                    <EcommerceConfigurationRulesEngineContainer
                        configuration={props.configuration}
                        onChangeCallback={handleOnChangeRulesSetCallback}
                    />
                }
            </div>
            <div className="row">
                <div className="col">
                    <ActionButton onClick={handleOnSubmitCallback}
                        type="button"
                        className="btn btn-primary float-right"
                        loadingTimeout={1000}
                    >
                        {props.intl.formatMessage(messages["submit_btn"])}
                    </ActionButton>
                </div>

            </div>
        </div>
    )

}

export default injectIntl(EcommerceConfigurationContainer)


// WEBPACK FOOTER //
// ./src/settings/ecommerce/sections/EcommerceConfigurationContainer.tsx